import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import {
  installAuthStorageSync,
  useAdminAuthStore,
} from "./stores/adminAuthStore";
import { installStaleChunkRecovery } from "./lib/staleChunkRecovery";

// A tab left open across a deploy asks for lazy chunks the new pod no longer has. Installed
// before anything renders, so the very first route import is already covered.
installStaleChunkRecovery();

// Adopt a rotation performed by another tab before anything can 401 with the pair this tab
// booted with. Installed ahead of the startup refresh for the same reason.
installAuthStorageSync();

// Check token on startup and refresh if needed. A failed refresh already clears the session and
// the route guard sends the operator to /login, so the rejection is handled here only to keep it
// from surfacing as an unhandled promise rejection during boot.
useAdminAuthStore
  .getState()
  .checkAndRefreshToken()
  .catch(() => {
    // Session could not be restored; the app renders the login route.
  });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
